const n = (e, f, o, s = !1) => {
  e.keyCode === f && (s && e.preventDefault(), o == null || o(e));
};
export {
  n as baseOnKeyDown
};
//# sourceMappingURL=index.es742.js.map
